<template>
    <div class="z-filelist-item" :class="buildClass">
        <div class="z-filelist-item__body">
            <div class="z-filelist-item__icon" v-if="icon || slots['icon']">
                <z-icon
                    v-if="icon"
                    :name="!oneSizeIcon ? `file/${iconSize}/${icon}` : icon"
                />
                <slot v-else name="icon"/>
            </div>
            <div class="z-filelist-item__slot">
                <div class="z-filelist-item__wrapper" v-if="date">
                    <span v-if="date" class="z-filelist-item__text" v-html="formattedDate"></span>
                </div>
                <slot/>
                <div class="z-filelist-item__wrapper z-filelist-item__wrapper--bottom" v-if="fileType || fileSize">
                    <span v-if="fileType" v-html="fileType" class="z-filelist-item__text"/>
                    <span v-if="fileSize" v-html="fileSize" class="z-filelist-item__text"/>
                </div>
                <slot name="link" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { useSlots } from 'vue'
import { computed } from 'vue'
import {momentFilter} from '@/utils/filter'

const slots = useSlots()

const props = defineProps({
    size: {
        type: String,
        validator: prop => ['l', 'm'].includes(prop),
        default: 'm'
    },
    icon: {
        type: String,
        // validator: prop => ['doc', 'docx', 'gif', 'jpeg', 'jpg', 'mp3', 'mp4', 'no-file', 'pdf', 'png', 'ppt', 'rar', 'tif', 'tiff', 'txt', 'webm', 'xls', 'xlsx', 'zip'].includes(prop),
        default: 'no-file'
    },
    oneSizeIcon: {
        type: Boolean,
        default: false
    },
    fileType: {
        type: String
    },
    fileSize: {
        type: String,
        default: ''
    },
    iconSize: {
        type: String,
        validator: prop => ['big', 'small'].includes(prop),
        default: 'big'
    },
    date: {
        type: [String, Number],
        default: ''
    },
    iconTop: {
        type: Boolean
    },
    centered: {
        type: Boolean,
        default: false
    }
})

// const iconSizeBig = 62
// const iconSizeSmall = 42


const formattedDate = computed(() => {
    return typeof (props.date) === 'number' ? `${momentFilter(props.date, 'DD MMMM YYYY')}` : props.date

})

const buildClass = computed(() => {
    return [
        {'z-filelist-item--with-icon': props.icon || slots.icon},
        {'z-filelist-item--icon-top': props.iconTop},
        {'z-filelist-item--centered': props.centered},
        `z-filelist-item--${props.size}`
    ]
})

defineExpose({
    props
})
</script>
